import { useQuery } from "@tanstack/react-query";
import { RoleServices } from "../core/_request";
import { formatMenuTreeData } from "../utils/formatTreeData";

export const useQueryAllMenusForRoleForm = (params?: any) => {
  return useQuery({
    queryKey: ["allMenus"],
    queryFn: async () =>
      await RoleServices.getRolesMenuList({ ...params, lvl: 0 }),
    select(data) {
      if (!Array.isArray(data?.data?.member)) {
        return [];
      }
      return formatMenuTreeData(data?.data?.member);
    },
  });
};
